import { render, staticRenderFns } from "./KoreanLiveCartNew.vue?vue&type=template&id=555b612c&scoped=true"
import script from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLiveCartNew.vue?vue&type=style&index=0&id=555b612c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555b612c",
  null
  
)

export default component.exports